import React from "react";

import MoonLoader from "react-spinners/MoonLoader";

import "./Spinner.css";

const override = `
  display: block;
`;

interface SpinnerProps {
  loading: boolean;
  inline?: boolean;
}

// TODO => Can we deprecate this and use mantine solution instead?
function Spinner(props: SpinnerProps) {
  const { loading, inline } = props;
  const _inline = inline ? "inline" : "";

  if (!loading) return null;

  return (
    <div className={`spinner ${_inline}`}>
      {/** @ts-expect-error the css override is not expected*/}
      <MoonLoader loading={loading} color={"var(--color-black)"} size={inline ? 35 : 150} css={override} />
    </div>
  );
}

export default Spinner;
